import { EventTriggerType } from '../../domain';
import { TriggerType } from '../../types';

// Protocol type union for Liquidity V3
export type LiquidityV3Protocol =
  | TriggerType.UniswapLiquidityV3
  | TriggerType.HyperswapLiquidityV3
  | TriggerType.HybraLiquidityV3
  | TriggerType.PrjXLiquidityV3
  | TriggerType.KittenSwapLiquidityV3
  | TriggerType.UltrasolidLiquidityV3
  | TriggerType.UpheavalLiquidityV3
  | TriggerType.NestLiquidityV3;

export type LiquidityV3EventTriggerType =
  | EventTriggerType.Uniswap
  | EventTriggerType.HyperswapLiquidityV3
  | EventTriggerType.HybraLiquidityV3
  | EventTriggerType.PrjXLiquidityV3
  | EventTriggerType.KittenSwapLiquidityV3
  | EventTriggerType.UltrasolidLiquidityV3
  | EventTriggerType.UpheavalLiquidityV3
  | EventTriggerType.NestLiquidityV3;

export interface LiquidityV3Config {
  protocol: LiquidityV3Protocol;
  protocolName: string;
  fallbackChainIds?: number[];
}

export const liquidityV3Config: Record<LiquidityV3EventTriggerType, LiquidityV3Config> = {
  [EventTriggerType.Uniswap]: {
    protocol: TriggerType.UniswapLiquidityV3,
    protocolName: EventTriggerType.Uniswap,
  },
  [EventTriggerType.HyperswapLiquidityV3]: {
    protocol: TriggerType.HyperswapLiquidityV3,
    protocolName: EventTriggerType.HyperswapLiquidityV3,
  },
  [EventTriggerType.HybraLiquidityV3]: {
    protocol: TriggerType.HybraLiquidityV3,
    protocolName: EventTriggerType.HybraLiquidityV3,
  },
  [EventTriggerType.PrjXLiquidityV3]: {
    protocol: TriggerType.PrjXLiquidityV3,
    protocolName: EventTriggerType.PrjXLiquidityV3,
  },
  [EventTriggerType.KittenSwapLiquidityV3]: {
    protocol: TriggerType.KittenSwapLiquidityV3,
    protocolName: EventTriggerType.KittenSwapLiquidityV3,
  },
  [EventTriggerType.UltrasolidLiquidityV3]: {
    protocol: TriggerType.UltrasolidLiquidityV3,
    protocolName: EventTriggerType.UltrasolidLiquidityV3,
  },
  [EventTriggerType.UpheavalLiquidityV3]: {
    protocol: TriggerType.UpheavalLiquidityV3,
    protocolName: EventTriggerType.UpheavalLiquidityV3,
  },
  [EventTriggerType.NestLiquidityV3]: {
    protocol: TriggerType.NestLiquidityV3,
    protocolName: EventTriggerType.NestLiquidityV3,
    fallbackChainIds: [999],
  },
};

// Helper to check if a trigger type is a Liquidity V3 type
export const isLiquidityV3TriggerType = (triggerType: EventTriggerType): triggerType is LiquidityV3EventTriggerType => {
  return triggerType in liquidityV3Config;
};
